import type {ActionTypes} from './createActionTypes';
import type {CrudAction} from './createActions';
import Sort from '../../../shared/constants/CRUD';

export function getValueFromPayload(obj: Object): Object {
    let newObj = {}
    for (let property in obj) {
        if (!!obj[property] && obj[property] !== '') {
            newObj[property] = obj[property]
        }
    }
    return newObj
}

export function createReducers(actionTypes: ActionTypes) {
    const INIT_STATE = {
        entities: [],
        total: 0,
        entity: {},
        loading: false,
        selected: []
    };

    type State = {
        page?: number,
        sizePerPage?: number,
        searchText?: string,
        sort?: Sort,
        filter?: Object,
        customParams?: Object,
        entities?: [] | null,
        entity?: {} | null,
        loading?: boolean,
        selected?: [] | null,
        +value?: boolean,
        listFirstTime: boolean,
        exportSubscriber?: string
    };

    return (state: State = INIT_STATE, action: CrudAction) => {
        switch (action.type) {
            case actionTypes.CLEAR:
                return {...INIT_STATE};
            case actionTypes.SELECT:
                return {...state, selected: action.payload};
            case actionTypes.GET:
                return {...state, loading: true};
            case actionTypes.GET_SUCCESS:
                return {...state, entity: action.payload, loading: false, error: null};
            case actionTypes.GET_FAILED:
                return {...state, error: action.payload, loading: false};
            case actionTypes.LIST:
                return {...state, loading: true, entities: [], ...getValueFromPayload(action.payload)};
            case actionTypes.LIST_SUCCESS:
                return {...state, ...action.payload, loading: false, error: null, listFirstTime: true};
            case actionTypes.LIST_FAILED:
                return {...state, error: action.payload, loading: false};
            case actionTypes.CREATE:
                return {...state, loading: true};
            case actionTypes.CREATE_SUCCESS:
                return {...state, entity: action.payload, loading: false, error: null};
            case actionTypes.CREATE_FAILED:
                return {...state, error: action.payload, loading: false};
            case actionTypes.DELETE:
                return {...state, loading: true};
            case actionTypes.DELETE_SUCCESS:
                return {...state, entity: {}, loading: false, error: null};
            case actionTypes.DELETE_FAILED:
                return {...state, error: action.payload, loading: false};
            case actionTypes.UPDATE:
                return {...state, loading: true};
            case actionTypes.UPDATE_SUCCESS:
                return {...state, entity: action.payload, loading: false, error: null};
            case actionTypes.UPDATE_FAILED:
                return {...state, error: action.payload, loading: false};
            case actionTypes.SHOW:
                return {...state, loading: true};
            case actionTypes.SHOW_SUCCESS:
                return {...state, entity: action.payload, loading: false, error: null};
            case actionTypes.SHOW_FAILED:
                return {...state, error: action.payload, loading: false};
            case actionTypes.EXPORT:
                return {...state, loading: true};
            case actionTypes.EXPORT_SUCCESS:
                return {...state, loading: false, error: null};
            case actionTypes.EXPORT_FAILED:
                return {...state, error: action.payload, loading: false};
            case actionTypes.EXPORT_BIG_DATA:
                return {...state, exportSubscriber: action.payload.key, loading: true};
            case actionTypes.EXPORT_BIG_DATA_SUCCESS:
                return {...state, error: null};
            case actionTypes.EXPORT_BIG_DATA_FAILED:
                return {...state, error: action.payload, loading: false};
            case actionTypes.DOWNLOAD_FROM_URL:
                return {...state, exportSubscriber: null, loading: true};
            case actionTypes.DOWNLOAD_FROM_URL_SUCCESS:
                return {...state, loading: false, error: null};
            case actionTypes.DOWNLOAD_FROM_URL_FAILED:
                return {...state, error: action.payload, loading: false};
            case actionTypes.EXPORT_DETAIL:
                return {...state, loading: true};
            case actionTypes.EXPORT_DETAIL_SUCCESS:
                return {...state, loading: false, error: null};
            case actionTypes.EXPORT_DETAIL_FAILED:
                return {...state, error: action.payload, loading: false};
            case actionTypes.UPLOAD:
                return {...state, loading: true};
            case actionTypes.UPLOAD_SUCCESS:
                return {...state, entity: action.payload, loading: false, error: null};
            case actionTypes.UPLOAD_FAILED:
                return {...state, error: action.payload, loading: false};
            case actionTypes.DOWNLOAD_TEMPLATE:
                return {...state, loading: true};
            case actionTypes.DOWNLOAD_TEMPLATE_SUCCESS:
                return {...state, loading: false, error: null};
            case actionTypes.DOWNLOAD_TEMPLATE_FAILED:
                return {...state, error: action.payload, loading: false};
            default:
                return {...state};
        }
    };
}
